let api_url = 'http://localhost:3000/api';
let tm_url = 'http://localhost:3000/live';
if(process.env.NODE_ENV != "development"){
	api_url = 'https://atirma.iusiani.ulpgc.es/api';
	tm_url = 'https://atirma.iusiani.ulpgc.es/live';
}

export {api_url, tm_url};